var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{attrs:{"hasFilter":false,"hasExportCSV":false,"hasExportXLSX":false,"opts":_vm.opts,"cols":_vm.cols,"customResource":_vm.customResource}})}
var staticRenderFns = []

export { render, staticRenderFns }